export default __webpack_public_path__ + "static/media/Förtunning no 1.5b5fd26e.jpg";